import { useMutation, useQuery } from "@tanstack/react-query";
import { createRating, getRatingStatus, updateRating } from "apis/ratings";

export function useRatingStatus(key, options = {}) {
  return useQuery({
    queryKey: ["ratingStatus", key],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data },
        } = await getRatingStatus(key);
        response = data;
      } catch (error) {
        throw new Error("Gagal mengambil data dari server!");
      }
      return response;
    },
    ...options,
  });
}

export function useCreateRating() {
  return useMutation({
    mutationFn: createRating,
  });
}

export function useUpdateRating() {
  return useMutation({
    mutationFn: updateRating,
  });
}
